import { render, staticRenderFns } from "./GuardRequest.vue?vue&type=template&id=1bef47f0&"
import script from "./GuardRequest.vue?vue&type=script&lang=js&"
export * from "./GuardRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports